import { z } from 'zod'

import DataSource from 'constants/sources/DataSource'
import { isZeusEnvironment } from 'utils/environment'

import {
  bulkCreateWalletsRequestSchema,
  bulkCreateWalletsResponseSchema,
  upsertWalletSchema,
  walletChains,
  walletResponseSchema,
  zeusWalletChains,
} from './walletApiSchema'

export type WalletAddress = string
export type WalletChain = Extract<DataSource, (typeof walletChains)[number]>
export type ZeusWalletChain = Extract<DataSource, (typeof zeusWalletChains)[number]>

export const isWalletChain = (source?: DataSource): source is WalletChain => {
  if (isZeusEnvironment()) {
    return zeusWalletChains.includes(source as ZeusWalletChain)
  }
  return walletChains.includes(source as WalletChain)
}

export type Wallet = z.infer<typeof walletResponseSchema>

export type UpsertWalletRequest = z.infer<typeof upsertWalletSchema>

export type BulkCreateWalletsRequest = z.infer<typeof bulkCreateWalletsRequestSchema>
export type BulkCreateWalletsResponse = z.infer<typeof bulkCreateWalletsResponseSchema>

export type WalletBackendIdentifierString = `${Wallet['addr']}@${DataSource}`

/**
 *  This delimiter is required to be attached to values sent over to the BE from the SourceFilter
 * */
export const SOURCE_DELIMITER = '@'
